import { render, staticRenderFns } from "./leaveIntership.vue?vue&type=template&id=c0777924&scoped=true"
import script from "./leaveIntership.vue?vue&type=script&lang=js"
export * from "./leaveIntership.vue?vue&type=script&lang=js"
import style0 from "./leaveIntership.vue?vue&type=style&index=0&id=c0777924&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0777924",
  null
  
)

export default component.exports